import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Terminal from './Terminal';

const DemoSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white section" id="demo">
      <div className="container">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl font-bold text-dblift-blue-dark mb-4">
              {t('demo.title').split(' ').slice(0, -1).join(' ')} <span className="text-dblift-orange">{t('demo.title').split(' ').pop()}</span>
            </h2>
            <p className="text-xl text-dblift-gray-dark max-w-3xl mx-auto">
              {t('demo.description')}
            </p>
          </motion.div>
        </div>

        <div className="flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="w-full"
          >
            <Terminal />
          </motion.div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-dblift-gray-light p-6 rounded-xl"
            >
              <h3 className="text-xl font-bold text-dblift-blue-dark mb-3">{t('demo.structureTitle')}</h3>
              <p className="text-dblift-gray-dark mb-4">
                {t('demo.structureDesc')}
              </p>
              <div className="bg-dblift-blue-dark text-white p-4 rounded-lg font-mono text-sm">
                <div>V1_0_0__Initial_schema.sql</div>
                <div>V1_0_1__Add_users_table.sql</div>
                <div>R__Create_view_active_users.sql</div>
                <div>U1_0_1__Remove_users_table.sql</div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="bg-dblift-gray-light p-6 rounded-xl"
            >
              <h3 className="text-xl font-bold text-dblift-blue-dark mb-3">{t('demo.tagsTitle')}</h3>
              <p className="text-dblift-gray-dark mb-4">
                {t('demo.tagsDesc')}
              </p>
              <div className="bg-dblift-blue-dark text-white p-4 rounded-lg font-mono text-sm">
                <div>V1_0_2__Create_products[catalog,init].sql</div>
                <div className="text-dblift-orange">$ dblift migrate --tags=catalog</div>
                <div className="text-dblift-gray-light">{t('demo.tagsOutput')}</div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="bg-dblift-gray-light p-6 rounded-xl"
            >
              <h3 className="text-xl font-bold text-dblift-blue-dark mb-3">{t('demo.configTitle')}</h3>
              <p className="text-dblift-gray-dark mb-4">
                {t('demo.configDesc')}
              </p>
              <div className="bg-dblift-blue-dark text-white p-4 rounded-lg font-mono text-sm">
                <div>database:</div>
                <div>&nbsp;&nbsp;url: jdbc:oracle:thin:@localhost:1521:XE</div>
                <div>&nbsp;&nbsp;schema: myschema</div>
                <div>&nbsp;&nbsp;username: myuser</div>
                <div>&nbsp;&nbsp;password: {"\"${DBLIFT_DB_PASSWORD}\""}</div>
                <div>migrations_dir: ./migrations</div>
                <div>log_format: html</div>
                <div>jdbc_driver_path: ./drivers/ojdbc8.jar</div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;